module.exports = __webpack_public_path__ + "img/17.a3cd346b.jpg";